import { css, Interpolation, Theme } from '@emotion/react'
import { theme } from '../../../theme/theme'

export const tableWrapper: Interpolation<Theme> = (theme) => css`
  .table-row {
    min-height: 70px;
  }

  .table-row .actions {
    box-sizing: border-box;
    height: 24px;
    display: flex;
    gap: 12px;
    align-items: end;
    transition: all ${theme.transitions.duration.standard}ms ${theme.transitions.easing.easeInOut};
    overflow: hidden;
  }

  .table-row:not(:hover) .actions {
    height: 0;
  }
`

export const titleWrapper: Interpolation<Theme> = css`
  display: flex;
  flex-direction: column;
`

export const headerWrapper: Interpolation<Theme> = css`
  position: relative;

  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;

  span {
    font-weight: 700;
  }
`

export const linksWrapper: Interpolation<Theme> = (theme) => css`
  display: flex;
  align-items: center;
  gap: 12px;

  margin-top: -41px;
  margin-left: auto;
  margin-bottom: ${theme.spacing(2)};

  ${theme.breakpoints.down(620)} {
    margin-top: ${theme.spacing(2)};
    justify-content: right;
    width: 100%;
  }

  ${theme.breakpoints.down(680)} {
    .hide-for-mobile {
      display: none;
    }
  }
`

export const toolbarWrapper: Interpolation<Theme> = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 24px;

  ${theme.breakpoints.down(680)} {
    .hide-for-mobile {
      display: none;
    }
  }
`

export const fullWidthForMobile: Interpolation<Theme> = css`
  ${theme.breakpoints.down(650)} {
    width: 100%;
  }
`

export const filters: Interpolation<Theme> = (theme) => css`
  ${theme.breakpoints.down(650)} {
    justify-content: right;

    .wrapper {
      width: 100%;

      > div:first-child {
        width: 100%;

        > div {
          width: calc(100% - 89px - 12px);
        }
      }
    }
  }
`

export const pagination: Interpolation<Theme> = css`
  ${theme.breakpoints.down(1500)} {
    width: 100%;
    justify-content: right;
  }
`

export const paginationTake: Interpolation<Theme> = (theme) => css`
  margin-bottom: ${theme.spacing(2)};
`

export const tabsWrapper: Interpolation<Theme> = css`
  height: 48px;
  display: flex;
  align-items: center;
  gap: 12px;

  button {
    font-size: inherit;
  }
`

export const platformsWrapper: Interpolation<Theme> = css`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

export const action: Interpolation<Theme> = css`
  height: 18px;
  padding: 0;
  min-width: 0;

  &.MuiButtonBase-root:hover {
    background: none;
  }
`

export const badge: Interpolation<Theme> = css`
  width: fit-content;
`
